module.exports = __webpack_public_path__ + "img/Porto Apartment - 21 of 85.c1101ed9.jpeg";